/**
 * Scroll an accordion row so its header sits just under the fixed site header.
 *
 * Called when a row opens. If the previously open row sits above this one its
 * panel is about to collapse, so the target is measured minus that panel's
 * height; one smooth scroll then lands correctly once the collapse finishes.
 *
 * On desktop (>= 1024px) the photo/accordion split is short enough to stay in
 * view, so we only scroll when the row is actually off screen.
 */
export function snapAccordionItem(row: HTMLElement, collapsingAbove?: HTMLElement | null): void {
  if (typeof window === 'undefined') return;
  const headerH = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-h')) || 0;
  const gap = 12;
  const rect = row.getBoundingClientRect();
  const collapse = collapsingAbove ? collapsingAbove.getBoundingClientRect().height : 0;
  const rowTopAfter = rect.top - collapse;
  const desktop = window.matchMedia('(min-width: 1024px)').matches;

  const offScreen = rowTopAfter < headerH || rowTopAfter > window.innerHeight * (desktop ? 0.85 : 0.35);
  if (!offScreen) return;

  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  window.scrollTo({ top: window.scrollY + rowTopAfter - headerH - gap, behavior: reduce ? 'auto' : 'smooth' });
}
